/** Copyright (c) 2020 T. Rowe Price. All rights reserved. */

import './CancelConfirmationModal.scss';

import noop from 'lodash/noop';
import { bool, func, string } from 'prop-types';
import React from 'react';

import {
  AAMBeaconButton,
  AAMBeaconModal
} from 'components/shared/Beacon';

const BeaconCancelConfirmationModal = ({
  cancelPrompt,
  cancelTitle,
  onCancel,
  onContinue,
  operationName,
  showModal,
  continueText,
  cancelText
}) => {
  return showModal ? (
    <AAMBeaconModal
      className="cancel-confirmation-modal"
      size="normal"
      disableClickOff
      hideAnchor
      hideClose
      open
      onBeaconEventClose={onCancel}
      id="grant-view-access-cancel-confirmation-modal"
      title=" ">
      {cancelTitle && (
        <div className="cancel-confirmation-modal-title">{cancelTitle}</div>
      )}
      <div className="cancel-confirmation-modal-content">{cancelPrompt}</div>
      <div slot="action-zone" className="cancel-confirmation-modal-buttons">
        <AAMBeaconButton
          id={`continue-${operationName}`}
          variant="tertiary"
          scale="normal"
          onBeaconEventClick={onContinue}
        >
          {continueText}
        </AAMBeaconButton>
        <AAMBeaconButton
          id={`cancel-${operationName}`}
          type="primary"
          scale="normal"
          onBeaconEventClick={onCancel}
        >
          {cancelText}
        </AAMBeaconButton>
      </div>
    </AAMBeaconModal>
  ) : null;
};

BeaconCancelConfirmationModal.propTypes = {
  cancelTitle: string,
  cancelPrompt: string.isRequired,
  onCancel: func.isRequired,
  onContinue: func.isRequired,
  operationName: string.isRequired,
  showModal: bool.isRequired,
  cancelText: string.isRequired,
  continueText: string.isRequired
};

BeaconCancelConfirmationModal.defaultProps = {
  cancelTitle: null,
  cancelPrompt: '',
  onCancel: noop,
  operationName: '',
  showModal: false,
  cancelText: 'No, Keep Editing',
  continueText: 'Yes, Leave'
};

export default BeaconCancelConfirmationModal;
